import axios, { formToJSON } from "axios";
import { HEADER_KEY_AUTH_ID, HEADER_KEY_SSID } from "@/data/constants";

export class ApiGatewayRepository {
    constructor() {
        this.ssid = localStorage.getItem("HVCHUBSYNCHSSID");
        this.auth_id = localStorage.getItem("auth_id");
        this.url = process.env.VUE_APP_API_URL;
    }

    async login(email, password) {
        const response = await this.call(process.env.VUE_APP_LOGIN_AND_REDIRECT_ENDPOINT, {
            email: email,
            password: password,
        }, false);
        return response.data;
    }

    async logout() {
        const response = await this.call(process.env.VUE_APP_LOGOUT_ENDPOINT);
        return response.data;
    }

    async resetPassword(email) {
        const response = await this.call(process.env.VUE_APP_CONSUMER_PASSWORD_REMINDER, {
            email: email,
        }, false);

        return response.data;
    }

    async checkSession() {
        this.ssid = localStorage.getItem("HVCHUBSYNCHSSID");
        this.auth_id = localStorage.getItem("auth_id");
        const response = await this.call(process.env.VUE_APP_SESSION_CHECK);
        return response.data;
    }

    async getTopPageData(params) {
        const response = await this.call(process.env.VUE_APP_TOP_PAGE, params);
        return response.data;
    }

    async getCreditCards() {
        const hubsynch_id = Number(localStorage.getItem('hubsynch_id'));

        let params = {
            hubsynch_id: hubsynch_id,
        };
        params[HEADER_KEY_SSID] = this.ssid;
        params[HEADER_KEY_AUTH_ID] = this.auth_id;

        const response = await this.call(process.env.VUE_APP_USER_CREDIT_CARD_ENDPOINT, params, true, false, "get");

        return response.data;
    }

    async createCreditCard(params) {
        const response = await this.call(process.env.VUE_APP_REGISTER_CREDIT_CARD_ENDPOINT, params);

        return response.data;
    }

    async updateCreditCard(params) {
        const response = await this.call(process.env.VUE_APP_REGISTER_CREDIT_CARD_ENDPOINT, params, true, false, "put");
        return response.data;
    }

    async deleteCreditCard(params) {
        const response = await this.call(process.env.VUE_APP_USER_CREDIT_CARD_ENDPOINT, params, true, false, "delete");
        return response.data;
    }
    
    async getPaygentTokenModule() {
        const response = await this.call(process.env.VUE_APP_PAYGENT_TOKEN_MODULE_ENDPOINT, {}, true, false, "get");
        return response.data;
    }

    async getShippingAddresses() {
        const response = await this.call(process.env.VUE_APP_SHIPPING_ADDRESS_ENDPOINT, {}, true, false, "get");
        return response.data;
    }

    async createShippingAddresses(params) {
        const response = await this.call(process.env.VUE_APP_SHIPPING_ADDRESS_ENDPOINT, params, true, false, "post");
        return response.data;
    }

    async updateShippingAddresses(params) {
        const response = await this.call(process.env.VUE_APP_SHIPPING_ADDRESS_ENDPOINT, params, true, false, "put");
        return response.data;
    }

    async deleteShippingAddress(params) {
        const response = await this.call(process.env.VUE_APP_SHIPPING_ADDRESS_ENDPOINT, params, true, false, "delete");
        return response.data;
    }

    async getPaymentTypes() {
        const response = await this.call(process.env.VUE_APP_USER_CREDIT_CARD_ENDPOINT, {
            hubsynch_id: localStorage.getItem("get", "hubsynch_id"),
        }, true, null);
        return response.data;
    }

    async register(registrationParams) {
        const response = await this.call(process.env.VUE_APP_REGISTER_ENDPOINT, registrationParams);
        return response.data;
    }

    async getPaymentHistory(params) {
        const response = await this.call(process.env.VUE_APP_PAYMENT_HISTORIES_ENDPOINT, params, true, null, "get");
        return response.data;
    }
    
    async getAccountInfo() {
        return await this.call(process.env.VUE_APP_ACCOUNT_ENDPOINT, {}, true, null, "get");
    }

    async updateAccountInfo(params) {
        return await this.call(process.env.VUE_APP_UPDATE_ACCOUNT_ENDPOINT, params, true, false, "put");
    }

    async resign(params) {
        const response = await this.call(process.env.VUE_APP_RESIGN_ENDPOINT, params, true, null, "delete");
        return response.data;
    }

    async getSubscribers(params) {
        return await this.call(process.env.VUE_APP_SUBSCRIBERS, params, true, false, "get");
    }

    async getNews(params){
        const response = await this.call(process.env.VUE_APP_NEWS_ENDPOINT, params, false, null, "get");
        return response.data;
    }

    async createContactUs(params){
        const response = await this.call(process.env.VUE_APP_CONTACTUS_ENDPOINT, params, false);
        return response.data;
    }

    async getInquiryCategories(params = {}){
        const response = await this.call(process.env.VUE_APP_INQUIRY_CATEGORY_ENDPOINT, params, false, null, "get");
        return response.data;
    }

    async sendAuthCode(params){
        const response = await this.call(process.env.VUE_APP_EMAIL_CHANGE_REQUEST_ENDPOINT, params);
        return response.data;
    }

    async verifyAuthCode(params){
        const response = await this.call(process.env.VUE_APP_EMAIL_CHANGE_ENDPOINT, params, true, null, "get");
        return response.data;
    }

    async canDeleteAccount() {
        const response = await this.call(process.env.VUE_APP_CAN_DELETE_ACCOUNT_ENDPOINT, {}, true, null, "get");
        return response.data;
    }

    async getCountries() {
        const response = await this.call(process.env.VUE_APP_COUNTRIES_ENDPOINT, {}, true, false, "get");
        return response.data;
    }

    async getActiveMerchants() {
        const response = await this.call(process.env.VUE_APP_MERCHANT_ENDPOINT, {}, true, false, "get");
        return response.data;
    }

    async call(endpoint, params = {}, addHeaders = true, additionalHeaders = null, method = "post") {
        let headers = {};
        if (addHeaders) {
            headers[HEADER_KEY_SSID] = this.ssid;
            headers[HEADER_KEY_AUTH_ID] = this.auth_id;

            if (additionalHeaders != null) {
                headers = {
                    ...headers,
                    ...additionalHeaders,
                };
            }
        }
        return await axios({
            method: method,
            url: this.url + endpoint,
            params: method === "get" || method == "delete" ? params : {},
            data: method != "get" ? params : {},
            headers: headers
        });
    }
}
